import closeIcon from '~/assets/icons/cross.svg';
import logo from '~/assets/icons/logo.png';
import { ImgIcon } from '~/components/ui/ImgIcon';
import { Text } from '~/components/ui/Text';
import { playSound, Sound } from '~/assets/sounds';
import { rage } from '~/rage';
import { StyledCloseButton, StyledContainer, StyledTitle } from './Head.styled';

const Head = () => {
	const handleClose = () => {
		playSound(Sound.ClickButton);
		rage.betaRewards
			.close()
			.catch((err) => rage.notifications.showException(err));
	};

	return (
		<StyledContainer>
			<StyledTitle>
				<img src={logo} />
				<Text style={{ fontSize: 18, fontWeight: 700, color: '#FFFFFF' }}>
					Пламенный привет
				</Text>
			</StyledTitle>
			<StyledCloseButton
				onClick={handleClose}
				onMouseEnter={() => playSound(Sound.LinkCursor)}
			>
				<ImgIcon icon={closeIcon} width={10} height={10} />
			</StyledCloseButton>
		</StyledContainer>
	);
};

export { Head };
